export enum Role {
  company = 'COMPANY',
  manager = 'MANAGER',
  support = 'SUPPORT',
  financial = 'FINANCIAL'
}